import { render, staticRenderFns } from "./OliveOilPage.vue?vue&type=template&id=46982a73&scoped=true"
import script from "./OliveOilPage.vue?vue&type=script&lang=js"
export * from "./OliveOilPage.vue?vue&type=script&lang=js"
import style0 from "./OliveOilPage.vue?vue&type=style&index=0&id=46982a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46982a73",
  null
  
)

export default component.exports